export const getDateString = (millisecondStamp: string) => {
  const date = millisecondStamp
    ? new Date(parseInt(millisecondStamp)).toLocaleDateString()
    : "-";
};

export const removeTime = (date = new Date()) => {
  return new Date(date.toDateString());
};
